import React, { useEffect } from 'react';
import { AppNavbar } from "./AppNavbar";
import { AppFooter } from "./AppFooter";
import { Home } from "../home/Home";
import {
    Routes,
    Route
} from "react-router-dom";
import Aparat from '../aboutus/Aparat/Aparat';
import AllNews from '../information/allnews/AllNews';
import Contacts from '../contacts/Contacts';
import Kasbxunar from '../enquiries/VocationalEducation';
import FirstPage from '../home/activity/FirstPage';
import SecondPage from '../home/activity/SecondPage';
import ThirdPage from '../home/activity/ThirdPage';
import FourthPage from '../home/activity/FourthPage';
import Fifthpage from '../home/activity/Fifthpage';
import OpenNews from '../information/allnews/OpenNews';
import Cooperation from '../aboutus/cooperation/Cooperation';
import Central from '../aboutus/central/Central';
import Leaders from '../aboutus/leaders/Leaders';
import PhotoGallery from '../information/photoGallery/PhotoGallery';
import Subsidiaries from '../aboutus/subsidiaries/Subsidiaries';
import Documents from '../d-ocuments/Documents';
import ToDrivingSchool from '../enquiries/ToDrivingSchool';
import OnlineEnquiries from '../enquiries/OnlineEnquiries';
import Error from './Error';
import { Xarita } from '../../Xarita';
import SixPage from '../home/activity/SixPage';
import CallCenter from '../younges/call-center/CallCenter';
import AllNewsYoung from '../younges/youngnews/AllNewsYoung';
import OpenNewsYoung from '../younges/youngnews/OpenNewsYoung';
import Anticor from '../anticor/Anticor';
import Vacancy from '../vacancy/Vacancy';
import Sports from '../../sports/Sports';
import OpenSport from '../../sports/OpenSport';
import Jobs from '../../jobs/Jobs';
import OpenJob from '../../jobs/OpenJob';


export function AppContainer() {
 
    return (
        <div className="wrapper app">
            <AppNavbar />
            <main className="main"> <Routes>
            <Route path='*' element={<Error />} />
  
            <Route path="/allnews/:id" element={<OpenNews />} />
                <Route path="/" element={<Home />}></Route>
                <Route path="/markaziy-kengash" element={<Central />} />
                <Route path="/rahbariyat" element={<Leaders />} />
                <Route path="/markaziy-aparat" element={<Aparat />} />
                <Route path="/filiallar" element={<Subsidiaries />} />
                <Route path="/vacancy" element={<Vacancy />}></Route>
                <Route path="/tashkilot/:id" element={<Cooperation />} />
                <Route path="/error" element={<Error />} />
                <Route path="/allnews" element={<AllNews />} />
                <Route path="/fotogalareya" element={<PhotoGallery />} />
                <Route path="/hujjatlar" element={<Documents />} />
                <Route path="/korrupsiya" element={<Anticor />} />
                <Route path="/kontaktlar" element={<Contacts />} />
                <Route path="/onlayn-murojat" element={<OnlineEnquiries />} />
                <Route path="/haydovchilik-maktabiga-yozilish" element={<ToDrivingSchool />} />
                <Route path="/kasb-hunar-maktabiga-yozilish" element={<Kasbxunar />} />
                <Route path="/yoshlar-va-fuqarolarni-manaviy-axloqiy" element={<FirstPage />} />
                <Route path="/sportning-texnik-va-amaliy-turlarini" element={<SecondPage />} />
                <Route path="/bolalar-osmirlar-va-chaqiruvgacha" element={<ThirdPage />} />
                <Route path="/yoshlar-va-fuqarolarni-mudofaa" element={<FourthPage />} />
                <Route path="/avtomototransport-vositalari-haydovchilarini" element={<Fifthpage />} />
                <Route path="/xalqaro-tashkilotlar-bilan-faol-hamkorlik-qilish" element={<SixPage />} />
                <Route path="/xarita/:id" element={<Xarita />} />
                <Route path="/allnews/ru/:id" element={<OpenNews />} />
                <Route path="/ru" element={<Home />}></Route>
                <Route path="/sportlar" element={<Sports />}></Route>
                <Route path="/sportlar/:id" element={<OpenSport />}></Route>
                <Route path="/kasblar" element={<Jobs />}></Route>
                <Route path="/kasblar/:id" element={<OpenJob />}></Route>
                <Route path="/markaziy-kengash/ru" element={<Central />} />
                <Route path="/rahbariyat/ru" element={<Leaders />} />
                <Route path="/markaziy-aparat/ru" element={<Aparat />} />
                <Route path="/filiallar/ru" element={<Subsidiaries />} />
              
                <Route path="/tashkilot/ru/:id" element={<Cooperation />} />
                <Route path="/call-center/ru" element={<CallCenter />} />
                <Route path="/call-center" element={<CallCenter />} />
                <Route path="/error/ru" element={<Error />} />
                <Route path="/allnews/ru" element={<AllNews />} />
                <Route path="/fotogalareya/ru" element={<PhotoGallery />} />
                <Route path="/hujjatlar/ru" element={<Documents />} />
                <Route path="/kontaktlar/ru" element={<Contacts />} />
                <Route path="/onlayn-murojat/ru" element={<OnlineEnquiries />} />
                <Route path="/haydovchilik-maktabiga-yozilish/ru" element={<ToDrivingSchool />} />
                <Route path="/kasb-hunar-maktabiga-yozilish/ru" element={<Kasbxunar />} />
                <Route path="/yoshlar-va-fuqarolarni-manaviy-axloqiy/ru" element={<FirstPage />} />
                <Route path="/sportning-texnik-va-amaliy-turlarini/ru" element={<SecondPage />} />
                <Route path="/bolalar-osmirlar-va-chaqiruvgacha/ru" element={<ThirdPage />} />
                <Route path="/yoshlar-va-fuqarolarni-mudofaa/ru" element={<FourthPage />} />
                <Route path="/avtomototransport-vositalari-haydovchilarini/ru" element={<Fifthpage />} />
                <Route path="/xalqaro-tashkilotlar-bilan-faol-hamkorlik-qilish/ru" element={<SixPage />} />
                <Route path="/xarita/ru/:id" element={<Xarita />} />
                <Route path="/yoshlar-uchun-yangiliklar" element={<AllNewsYoung />} />
                <Route path="/yoshlar-uchun-yangiliklar/ru" element={<AllNewsYoung />} />
                <Route path="/yoshlar-uchun-yangiliklar/ru/:id" element={<OpenNewsYoung />} />
            <Route path="/yoshlar-uchun-yangiliklar/:id" element={<OpenNewsYoung />} />
            <Route path="/korrupsiya/ru" element={<Anticor />} />
            <Route path="/vacancy/ru" element={<Vacancy />}></Route>
                <Route path="/sportlar/ru" element={<Sports />}></Route>
                <Route path="/sportlar/ru/:id" element={<OpenSport />}></Route>
                <Route path="/kasblar/ru" element={<Jobs />}></Route>
                <Route path="/kasblar/ru/:id" element={<OpenJob />}></Route>
            </Routes></main>
            <AppFooter />
        </div>
    );
}

